/**
 * Central Lucide icon registry for the navigation module.
 *
 * The Nav Item form exposes these as a dropdown, and the frontend
 * `getNavIcon()` helper resolves the chosen name to the actual component.
 *
 * Adding a new icon: import it from lucide-react below, then add it to
 * NAV_ICON_OPTIONS with a human-readable label. That's it — the picker
 * updates automatically and the rendered nav item picks up the change.
 */
import {
  Home,
  Tag,
  Mail,
  Phone,
  Info,
  Building2,
  MapPin,
  Users,
  Briefcase,
  HelpCircle,
  Newspaper,
  Image as ImageIcon,
  BookOpen,
  Calendar,
  Star,
  FileText,
  LogIn,
  LogOut,
  Folder,
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  Store,
  Package,
  CreditCard,
  Receipt,
  Heart,
  Search,
  Settings,
  User,
  Menu,
  Grid3x3,
  Layers,
  MessageSquare,
} from "lucide-react";

// Map of "icon name string" → Lucide component. Keep the key equal to the
// component's PascalCase name so the admin can type it directly if they want
// (and existing docs with legacy free-text values keep working).
export const NAV_ICON_MAP = {
  Home, Tag, Mail, Phone, Info, Building2, MapPin, Users, Briefcase,
  HelpCircle, Newspaper, Image: ImageIcon, BookOpen, Calendar, Star,
  FileText, LogIn, LogOut, Folder,
  ShoppingCart, ShoppingBag, ShoppingBasket, Store, Package, CreditCard,
  Receipt, Heart, Search, Settings, User, Menu, Grid3x3, Layers, MessageSquare,
};

// Ordered list used by the admin picker. Grouped so shop/basket icons stay
// together at the bottom for discoverability.
export const NAV_ICON_OPTIONS = [
  { value: "", label: "— Auto (based on title/path)" },
  { value: "Home", label: "Home" },
  { value: "Building2", label: "Building" },
  { value: "MapPin", label: "Map Pin" },
  { value: "Users", label: "Users / Team" },
  { value: "User", label: "User" },
  { value: "Tag", label: "Tag / Price" },
  { value: "Mail", label: "Mail" },
  { value: "Phone", label: "Phone" },
  { value: "Info", label: "Info" },
  { value: "Briefcase", label: "Briefcase" },
  { value: "HelpCircle", label: "Help / FAQ" },
  { value: "Newspaper", label: "Newspaper / Blog" },
  { value: "Image", label: "Image / Gallery" },
  { value: "BookOpen", label: "Book / Guides" },
  { value: "Calendar", label: "Calendar" },
  { value: "Star", label: "Star" },
  { value: "Heart", label: "Heart / Saved" },
  { value: "FileText", label: "File / Page" },
  { value: "Folder", label: "Folder" },
  { value: "LogIn", label: "Log in" },
  { value: "LogOut", label: "Log out" },
  { value: "Search", label: "Search" },
  { value: "Settings", label: "Settings" },
  { value: "Menu", label: "Menu" },
  { value: "Grid3x3", label: "Grid" },
  { value: "Layers", label: "Layers" },
  { value: "MessageSquare", label: "Message" },
  // Shop / basket / payment
  { value: "ShoppingCart", label: "Shopping Cart" },
  { value: "ShoppingBag", label: "Shopping Bag" },
  { value: "ShoppingBasket", label: "Shopping Basket" },
  { value: "Store", label: "Store" },
  { value: "Package", label: "Package" },
  { value: "CreditCard", label: "Credit Card" },
  { value: "Receipt", label: "Receipt" },
];
